"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isRange_1 = require("../typeUtils/isRange");
function contains(container, contained, treatSameNodeAsContain) {
    if (!container || !contained) {
        return false;
    }
    if (treatSameNodeAsContain && container == contained) {
        return true;
    }
    if (isRange_1.default(contained)) {
        contained = contained && contained.commonAncestorContainer;
        treatSameNodeAsContain = true;
    }
    if (contained && contained.nodeType == 3 /* Text */) {
        contained = contained.parentNode;
        treatSameNodeAsContain = true;
    }
    if (container.nodeType != 1 /* Element */ && container.nodeType != 11 /* DocumentFragment */) {
        return !!treatSameNodeAsContain && container == contained;
    }
    return !!(treatSameNodeAsContain || container != contained) && container.contains(contained);
}
exports.default = contains;
//# sourceMappingURL=contains.js.map